const common_ua = new UAChecker();
var common_sw = new isScreenW();
const userAgent = window.navigator.userAgent;

window.addEventListener('load', () => {
  if (userAgent.indexOf('Edg') !== -1) {
    document.body.classList.add('is_edge');
  }
  if (userAgent.indexOf('msie') !== -1 || userAgent.indexOf('Trident') !== -1) {
    document.body.classList.add('is_ie');
  }
  if (common_ua.isAndroid) {
    document.body.classList.add('is_android');
  }
  if (!common_ua.isPc) {
    document.body.classList.add('is_sp');
  }
  
  // dummy
  
  // SPナビ
  document.addEventListener("click", (event) => {
    if (event.target.classList.contains("sNtrigger")) {
      document.querySelector("#headTop").classList.toggle("open");
    }
    if (event.target.classList.contains("t")) {
      event.target.classList.toggle("open");
    }
  });
  
  // テーブル用
  const tableOuter = document.querySelector(".tableOuter.spWide");
  if (tableOuter) {
    tableOuter.addEventListener("scroll", () => {
      tableOuter.classList.add("sc_rmv");
    });
  }
  
  // サイドナビ非表示
  if (common_sw.isMin) {
    document.querySelector("#sideFixed").style.display = "none";
  }
  
  // 
  const sNaviH = document.querySelector("#headTop").offsetHeight;
  const mH = document.querySelector("#navi").offsetHeight;
  //document.querySelector("#subNav").style.top = `${sNaviH + mH}px`;
  
  // PC NAVI 追従 ==================================================
  const fixElementName = "#headMid";
  const fixClass = "is-fixed";
  const fixFunction = () => {
    const $fixElement = document.querySelector(fixElementName);
    const baseFixPoint = $fixElement.offsetTop + document.querySelector("#subNav").offsetHeight;
    const windowScrolltop = window.pageYOffset;
    if (windowScrolltop >= baseFixPoint) {
      $fixElement.classList.add(fixClass);
    } else {
      $fixElement.classList.remove(fixClass);
    }
  };
  window.addEventListener("scroll", fixFunction);
  // ============================================================
  
  // アコーディオン ==================================================
  const accordionHeaders = document.querySelectorAll(".accordion_header");
  accordionHeaders.forEach(header => {
    header.addEventListener("click", () => {
      const inner = header.nextElementSibling;
      inner.classList.toggle("open");
      inner.style.display = inner.classList.contains("open") ? "block" : "none";
      header.classList.toggle("open");
    });
  });
  // ===========================================================
  
  // スクロール
  // window.addEventListener("scroll", () => {
  //   if (common_sw.isLrg) {
  //     return;
  //   }
  //   if (window.pageYOffset > 700) {
  //     document.querySelector("#bottomFloat").style.display = "block";
  //   } else {
  //     document.querySelector("#bottomFloat").style.display = "none";
  //   }
  // });
  
  // document.querySelectorAll('a[href^="#"]').forEach(anchor => {
  //   anchor.addEventListener('click', function (e) {
  //   e.preventDefault();
  //   const speed = 400; // スクロールの速度（ミリ秒）
  //   const href = this.getAttribute('href');
  //   const target = document.querySelector(href === '#' || href === '' ? 'html' : href);
  //   const position = target.getBoundingClientRect().top;
  //   window.scrollTo({
  //   top: position,
  //   behavior: "smooth"
  //   });
  //   });
  //   });
    
  });
 /* 画面サイズ判断 */
 function isScreenW() {
  let selfW = this;
  selfW.isMin = false;
  selfW.isLrg = false;
  if (window.innerWidth > 980) {
  selfW.isLrg = true;
  } else {
  selfW.isMin = true;
  }
  }
  
  var common_sw = new isScreenW();
  
  window.addEventListener('resize', function() {
  common_sw = new isScreenW();
  })

  /*===================================*/
/* ユーザーエージェント              */
/*===================================*/
function UAChecker() {
  var self = this;
  self.isIE = false;
  self.isIE6 = false;
  self.isIE7 = false;
  self.isIE8 = false;
  self.isIE9 = false;
  self.isIE10 = false;
  self.isIE11 = false;
  self.isIPhone = false;
  self.isIPad = false;
  self.isAndroid = false;
  self.isFF = false;
  self.isChrome = false;
  self.isSafari = false;
  self.isWindows = false;
  self.isMac = false;
  self.isPc = false;
  self.userAgent = window.navigator.userAgent.toLowerCase();
  self.appVersion = window.navigator.appVersion.toLowerCase();
  self.platform = window.navigator.platform.toLowerCase();
  if (self.userAgent.indexOf('msie') != -1) {
      self.isIE = true;
      if (self.appVersion.indexOf('msie 6.') != -1) {
          self.isIE6 = true;
      }
      if (self.appVersion.indexOf('msie 7.') != -1) {
          self.isIE7 = true;
      }
      if (self.appVersion.indexOf('msie 8.') != -1) {
          self.isIE8 = true;
      }
      if (self.appVersion.indexOf('msie 9.') != -1) {
          self.isIE9 = true;
      }
      if (self.appVersion.indexOf('msie 10.') != -1) {
          self.isIE10 = true;
      }
      if (self.appVersion.indexOf('msie 11.') != -1) {
          self.isIE11 = true;
      }
  }
  if (self.userAgent.indexOf('iphone') != -1) {
      self.isIPhone = true;
  }
  if (self.userAgent.indexOf('ipad') != -1) {
      self.isIPad = true;
  }
  if (self.userAgent.indexOf('android') != -1) {
      self.isAndroid = true;
  }
  if (self.userAgent.indexOf('firefox') != -1) {
      self.isFF = true;
  }
  if (self.userAgent.indexOf('chrome') != -1) {
      self.isChrome = true;
  }
  if (self.userAgent.indexOf('safari') != -1) {
      self.isSafari = true;
  }
  if (self.platform.indexOf('win') != -1) {
      self.isWindows = true;
      self.isPc = true;
  }
  if (self.platform.indexOf('mac') != -1) {
      self.isMac = true;
      self.isPc = true;
  }

}
